import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setBulkUpdateField, setBulkUpdateValue } from 'store/Credentials/actions';
import LinkedVulns from 'Screens/Credentials/components/CreateEditModal/components/LinkedVulns';

const LinkedVulnerabilities = () => {
  const [vulns, setVulns] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBulkUpdateField('vulnerabilities'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setBulkUpdateValue(vulns));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vulns]);

  return (
    <LinkedVulns vulns={ vulns } setLinkedVuln={ setVulns } />
  );
};

export default LinkedVulnerabilities;
